import type { ResolvedModuleRuntimeUi } from '@hibro/shared';

/** Build a moduleId → `hibro-assets://` UI URL map from {@link ResolvedContributions.runtimeUiEntries}. */
export function buildRuntimeUiUrlMap(
  entries: readonly ResolvedModuleRuntimeUi[],
): ReadonlyMap<string, string> {
  const map = new Map<string, string>();
  for (const entry of entries) {
    map.set(entry.moduleId, entry.url);
  }
  return map;
}
